import { render, staticRenderFns } from "./miniProgram.vue?vue&type=template&id=0c95ebd8&scoped=true&"
import script from "./miniProgram.vue?vue&type=script&lang=js&"
export * from "./miniProgram.vue?vue&type=script&lang=js&"
import style0 from "./miniProgram.vue?vue&type=style&index=0&id=0c95ebd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95ebd8",
  null
  
)

export default component.exports